import { Injectable } from '@angular/core';

@Injectable()
export class SortService {
  sortArray(list: Array<any>, args: Array<any>, desc?:boolean) {
    if (!list || !list.sort) { return list; }

    var a2: string;
    var b2: string;
    var tt: string;
    var attrSplit: Array<string>;

    return list.sort((a: any, b: any) => {
      for (let key in args) {
        attrSplit = args[key].split(".");
        a2 = a;
        b2 = b;

        for (let keyY in attrSplit) {
          tt = a2[attrSplit[keyY]];
          if (tt) {
            a2 = tt;
          }

          tt = b2[attrSplit[keyY]];
          if (tt) {
            b2 = tt;
          }
        }
      }

      if (typeof a2 === 'string') {
        var itemA: string =  a2.toLowerCase();
        var itemB: string =  b2.toLowerCase();

        itemA =  this.removeAccents(itemA);
        itemB =  this.removeAccents(itemB);

        if (desc) {
          //decrescente
          if (itemA > itemB) { return -1; }
          if (itemA < itemB) { return 1; }
        } else {
          if (itemA < itemB) { return -1; }
          if (itemA > itemB) { return 1; }
        }
      }

      return 0;
    });
  }

  private removeAccents(value: any) {
    return value
      .replace(/á/g, 'a')
      .replace(/â/g, 'a')
      .replace(/à/g, 'a')
      .replace(/ã/g, 'a')
      .replace(/é/g, 'e')
      .replace(/è/g, 'e')
      .replace(/ê/g, 'e')
      .replace(/í/g, 'i')
      .replace(/ì/g, 'i')
      .replace(/î/g, 'i')
      .replace(/ó/g, 'o')
      .replace(/ò/g, 'o')
      .replace(/ô/g, 'o')
      .replace(/õ/g, 'o')
      .replace(/ú/g, 'u')
      .replace(/ù/g, 'u')
      .replace(/û/g, 'u')
      .replace(/ç/g, 'c');
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/services/sort.service.ts
 **/